import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './app.routes';
import { authInterceptor } from './core/auth.interceptor';
export const appConfig: ApplicationConfig = { providers: [provideZoneChangeDetection({eventCoalescing:true}), provideRouter(routes), provideHttpClient(withInterceptors([authInterceptor]))] };
